import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { sha512 } from 'hash-anything';
import {
  FaSignOutAlt,
  FaReceipt,
  FaCog,
  FaClipboard,
  FaBars,
  FaEllipsisV,
  FaListUl,
  FaUsers,
  FaCalendarAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaSpinner
} from 'react-icons/fa';
import NavViews from '../stores/NavViews';
import ChildAccounts from './ChildAccounts';
import GroupSettings from './GroupSettings';
import { updateProfileImageLocation, changePassword, addKidToGroup, updateUser } from '../api_calls/user';
import { slide as MobileMenu } from 'react-burger-menu';
import ImageUploader from 'react-images-upload';
import AWS from 'aws-sdk';
import _ from 'underscore';
import { updateGroup } from '../api_calls/group';
import { menu as menuStyles, settings as settingStyles } from '../utils/styles/menuStyles';
import { allThemes } from '../utils/styles/colours';
import { createLog } from '../api_calls/logging';
import { message } from '../utils/feedback';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';

const allowedImageTypes = ['image/jpeg'];
const maxImageSize = 5000000;
const mobileWidth = 580;

const albumBucketName = 'listgifts-pics';
const bucketRegion = 'us-east-2';
const IdentityPoolId = 'us-east-2:e467c664-233b-4e2b-ac1f-36d6fb672768';

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId
  })
});

const s3 = new AWS.S3({
  apiVersion: '2006-03-01',
  params: { Bucket: albumBucketName, ContentType: 'image/jpeg' },
  accessKeyId: process.env.AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY
});

@observer(['UserStore', 'ViewStore', 'CustomRouter', 'AuthStore', 'FamilyStore', 'MyListStore'])
class MyHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      selectedKey: '1',
      pictures: [],
      settingsVisible: false,
      drops: 0,
      childOptionsVisible: false,
      uploadingImage: false,
      modalOpen: false,
      mobileMenuOpen: false,
      activeGroup: undefined
    };

    this.onDrop = this.onDrop.bind(this);
    this.onSettingsClicked = this.onSettingsClicked.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChildOptionsChange = this.onChildOptionsChange.bind(this);
    this.addPhoto = this.addPhoto.bind(this);
    this.deletePhoto = this.deletePhoto.bind(this);
    this.onSubmitPassChangeClick = this.onSubmitPassChangeClick.bind(this);
    this.addChildToGroup = this.addChildToGroup.bind(this);
    this.dontAddChildToGroup = this.dontAddChildToGroup.bind(this);
    this.activeGroup = this.activeGroup.bind(this);
    this.giftRankingPermissionChange = this.giftRankingPermissionChange.bind(this);
    this.giftRankingMaxChange = this.giftRankingMaxChange.bind(this);
    this.onThemeChange = this.onThemeChange.bind(this);
    this.onDesktopNavClick = this.onDesktopNavClick.bind(this);
  }

  getThemeKeys() {
    return _.keys(allThemes);
  }

  getSelectedThemeIndex() {
    const { UserStore } = this.props;
    return this.getThemeKeys().indexOf(UserStore.user.settings.theme);
  }

  onDesktopNavClick(key, view) {
    this.setState({ selectedKey: key });
    this.props.CustomRouter.router.goTo(view);
  }

  deletePhoto(albumName, photoKey) {
    s3.deleteObject({ Key: photoKey }, function onDelete(err) {
      if (err) {
        alert(`There was an error deleting your photo: ${err.message}`);
        return;
      }
      alert('Successfully deleted photo.');
    });
  }

  componentDidUpdate() {
    const { UserStore, FamilyStore } = this.props;
    const stateComplete = this.state.updateComplete;

    if (UserStore.children && UserStore.children.length && UserStore.childViewActive && !this.state.wrongGroupModalOpen) {
      const thisChild = _.findWhere(UserStore.children, { _id: UserStore.activeChild.id });
      if (thisChild && thisChild._id.concat(FamilyStore.activeGroupId) !== stateComplete && !_.findWhere(thisChild.groups, { id: FamilyStore.activeGroupId })) {
        this.setState({
          wrongGroupModalOpen: true
        });
      }
    }
  }

  addPhoto(file, albumName) {
    const { UserStore, AuthStore } = this.props;
    const userId = UserStore.user._id;
    const albumPhotosKey = `${encodeURIComponent(albumName)}/`;
    const photoKey = albumPhotosKey.concat(userId).concat('.jpg');
    const self = this;

    const upload = s3.upload({
      Key: photoKey,
      Body: file
    });

    upload.promise().then(
      function onUpload(data) {
        self.setState({ uploadingImage: false });
        message.info('Successfully uploaded photo!');
        UserStore.setProfileImage(data.Location);

        updateProfileImageLocation(data.Location, UserStore.user._id, AuthStore.userAuth.auth.accessToken).then(() => {
          self.setState({ pictures: [] });
          const tags = document.getElementsByClassName('profile-img-settings');
          setTimeout(() => {
            for (const item of tags) {
              item.src = data.Location;
            }
          }, 50);
          return UserStore.refreshUser(AuthStore.userAuth.auth.accessToken);
        });
      },
      function onUploadError(err) {
        self.setState({ uploadingImage: false });
        message.error('There was an error uploading your photo...');
        console.error(err.message);
      }
    );
  }

  componentWillMount() {
    const currentPath = this.props.CustomRouter.router.currentPath;
    if (currentPath === '' || currentPath === '/') {
      this.setState({ selectedKey: '1' });
    }
    if (currentPath === '/groups') {
      this.setState({ selectedKey: '2' });
    }
    if (currentPath === '/events') {
      this.setState({ selectedKey: '3' });
    }
    if (currentPath === '/my-notes') {
      this.setState({ selectedKey: '4' });
    }
    if (currentPath === '/receipts') {
      this.setState({ selectedKey: '5' });
    }
  }

  componentDidMount() {
    this.setState({ childOptionsVisible: this.props.UserStore.user.childOptionsVisible, activeGroup: this.props.FamilyStore.activeGroupId });
    const self = this;
    document.addEventListener('visibilitychange', function logData() {
      if (document.visibilityState === 'hidden') {
        const endObj = {
          userId: self.props.UserStore.user._id,
          type: 'sessionEnd'
        };
        createLog(self.props.AuthStore.userAuth.auth.accessToken, endObj);
      }
      if (document.visibilityState === 'visible') {
        const startObj = {
          userId: self.props.UserStore.user._id,
          type: 'sessionStart',
          log: 'fromHidden'
        };
        createLog(self.props.AuthStore.userAuth.auth.accessToken, startObj);
      }
    });
  }

  onSettingsClicked() {
    this.setState({ settingsVisible: true, childOptionsVisible: this.props.UserStore.user.childOptionsVisible });
    const imageFile = this.props.UserStore.profileImage;
    const tags = document.getElementsByClassName('profile-img-settings');
    setTimeout(() => {
      for (const item of tags) {
        item.src = imageFile;
      }
    }, 50);
  }

  onClose() {
    this.setState({ settingsVisible: false });
  }

  onDrop(picture) {
    this.setState({ drops: this.state.drops + 1 });

    const selectedFile = this.state.drops - 1 > 0 ? this.state.pictures.concat(picture)[0] : this.state.pictures.concat(picture)[this.state.pictures.concat(picture).length - 1];

    if (selectedFile && selectedFile.type && allowedImageTypes.includes(selectedFile.type)) {
      const imageTag = document.getElementsByClassName('profile-img')[0];
      if (imageTag) {
        imageTag.title = selectedFile.name;
      }
      if (selectedFile.size && selectedFile.size < maxImageSize) {
        this.setState({ uploadingImage: true });
        this.addPhoto(selectedFile, 'profile-images');
      } else {
        message.warn('That image is too big!');
      }
    } else if (selectedFile && selectedFile.type && !allowedImageTypes.includes(selectedFile.type)) {
      message.warn("That file type is not supported! Try a '.jpg'");
    } else {
      message.warn("Sorry, that didn't work. Maybe the file is too big or the wrong type");
    }
  }

  onChange(value) {
    const { UserStore, FamilyStore } = this.props;
    this.setState({ activeGroup: value });
    this.props.FamilyStore.setActiveGroup(value);
    const realUser = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
    this.props.MyListStore.loadGiftsForUser(realUser, realUser, FamilyStore.activeGroupId);
  }

  activeGroup() {
    return this.props.FamilyStore.activeGroupId;
  }

  onChildOptionsChange(e) {
    this.props.UserStore.setChildOptionsVisible(e.target.checked);
  }

  onSubmitPassChangeClick() {
    const { UserStore, AuthStore } = this.props;
    const auth = AuthStore.userAuth.auth.accessToken;
    const passHash = this.state.hashPass;
    const newPassHash = this.state.newHashPass;
    const newPassHashConf = this.state.newHashPassConfirm;

    if (!newPassHash || !newPassHashConf || !passHash) {
      message.warn('Please complete all fields');
    } else if (newPassHashConf !== newPassHash) {
      message.warn('New password and confirmation do not match!');
    } else {
      changePassword(UserStore.user._id, passHash, newPassHash, auth).then(() => {
        this.setState({ modalOpen: false });
      });
    }
  }

  addChildToGroup() {
    const { AuthStore, UserStore } = this.props;
    const auth = AuthStore.userAuth.auth.accessToken;
    const groupId = this.props.FamilyStore.activeGroupId;
    const groupName = this.props.FamilyStore.activeGroupName;
    const userId = this.props.UserStore.activeChild.id;
    const self = this;

    addKidToGroup(auth, groupId, groupName, userId).then((res) => {
      if (res && res._id === groupId) {
        message.success('Added child to group!');
        UserStore.refreshUser(AuthStore.userAuth.auth.accessToken, groupId).then(() => {
          self.setState({
            wrongGroupModalOpen: false,
            updateComplete: userId.concat(groupId)
          });
        });
      } else {
        self.setState({ wrongGroupModalOpen: false });
      }
    });
  }

  dontAddChildToGroup() {
    const { FamilyStore, UserStore } = this.props;
    const thisKid = _.findWhere(UserStore.children, { _id: UserStore.activeChild.id });
    FamilyStore.setActiveGroup(thisKid.groups[0].id);
    UserStore.refreshGroups(thisKid.groups[0].id);
    this.setState({ wrongGroupModalOpen: false, activeGroup: thisKid.groups[0].id });
  }

  giftRankingPermissionChange(e) {
    const { FamilyStore, AuthStore, UserStore } = this.props;
    updateGroup(FamilyStore.activeGroupId, this.props.AuthStore.userAuth.auth.accessToken, { settings: { allowRankings: e.target.checked } }).then((res, err) => {
      if (res && res.status === 200) {
        UserStore.refreshUser(AuthStore.userAuth.auth.accessToken, FamilyStore.activeGroupId);
        message.success('Settings changed!');
      } else {
        message.error(err);
      }
    });
  }

  giftRankingMaxChange(value) {
    const { FamilyStore, AuthStore, UserStore } = this.props;
    updateGroup(FamilyStore.activeGroupId, this.props.AuthStore.userAuth.auth.accessToken, { settings: { rankingMax: value } }).then((res, err) => {
      if (res && res.status === 200) {
        UserStore.refreshUser(AuthStore.userAuth.auth.accessToken, FamilyStore.activeGroupId);
        message.success('Settings changed!');
      } else {
        message.error(err);
      }
    });
  }

  showSettings(event) {
    event.preventDefault();
  }

  onThemeChange(event) {
    const { UserStore, AuthStore, FamilyStore } = this.props;
    const id = UserStore.user._id;
    const token = AuthStore.userAuth.auth.accessToken;
    const mongo = { settings: { theme: _.keys(allThemes)[parseInt(event.target.value, 10)] } };
    updateUser(id, token, mongo).then((res) => {
      if (res && res.status && res.status === 200) {
        message.success('Theme updated!');
        UserStore.refreshUser(token, FamilyStore.activeGroupId);
      } else {
        message.error('Problem updating theme...');
      }
    });
  }

  renderDesktopMenuItem(item) {
    const isSelected = this.state.selectedKey === item.key;
    return (
      <button
        type="button"
        key={item.key}
        className={`topBarMenuItem ${isSelected ? 'topBarMenuItem-active' : 'topBarMenuItem-inactive'}`}
        onClick={() => this.onDesktopNavClick(item.key, item.view)}
      >
        {item.icon}
        <span>{item.label}</span>
      </button>
    );
  }

  render() {
    const { CustomRouter, UserStore, FamilyStore } = this.props;

    const mobileMenuItemStyles = {
      color: UserStore.theme().font
    };

    const themeKeys = this.getThemeKeys();
    const selectedThemeIndex = this.getSelectedThemeIndex();

    const navItems = [
      { key: '1', label: 'List', icon: <FaListUl style={{ marginRight: '6px' }} />, view: NavViews.home },
      { key: '2', label: 'Group', icon: <FaUsers style={{ marginRight: '6px' }} />, view: NavViews.groups },
      { key: '3', label: 'Events', icon: <FaCalendarAlt style={{ marginRight: '6px' }} />, view: NavViews.events },
      { key: '4', label: 'Notes', icon: <FaClipboard style={{ marginRight: '6px' }} />, view: NavViews.myNotes },
      { key: '5', label: 'Records', icon: <FaReceipt style={{ marginRight: '6px' }} />, view: NavViews.receipts }
    ];

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    const settings = (
      <div className="settings-panel neumorphic-panel" style={{ color: 'var(--text-color)' }}>
        <div className="settings-profile-card">
          <div className="settings-profile-head AppFont">
            <img alt="" className="profile-img-settings settings-avatar" />
            <div className="settings-profile-name">{this.props.UserStore.user.name}</div>
          </div>

          {this.state.uploadingImage ? (
            <div className="settings-uploading-status">
              Uploading Image... <FaSpinner className="pulse" style={{ fontSize: '14pt' }} />
            </div>
          ) : (
            ''
          )}

          <div className="settings-upload-wrap" style={{ filter: this.state.uploadingImage ? 'blur(5px)' : '', pointerEvents: this.state.uploadingImage ? 'none' : '' }}>
            <ImageUploader
              buttonStyles={{ backgroundColor: UserStore.theme().icons }}
              fileContainerStyle={{ backgroundColor: UserStore.theme().background }}
              label={`Max file size is ${maxImageSize / 1000 / 1000}MB`}
              withIcon={false}
              buttonText="Change Profile Image"
              onChange={this.onDrop}
              imgExtension={['.jpg', '.gif', '.png']}
              maxFileSize={10000000}
            />
          </div>
        </div>

        {this.props.UserStore.user.groups.length < 2 ? null : (
          <div className="settings-section-card" style={{ position: 'relative' }} id="activeGroupContainer">
            <div className="settings-section-title">Active Group</div>
            <div className="settings-section-subtitle">Switch context for lists, events, and notes</div>
            <select
              id="activeGroupSelect"
              className="neumorphic-select settings-select"
              onChange={(event) => this.onChange(event.target.value)}
              value={this.state.activeGroup || ''}
            >
              {this.props.UserStore.user.groups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {FamilyStore.activeGroup.creator === UserStore.user._id ? (
          <div className="settings-section-card">
            <span className="settings-section-title">Group Settings</span>
            <div className="settings-grid-rows">
              <label className="settings-switch-row">
                <span>Gift Ranking</span>
                <input
                  type="checkbox"
                  checked={FamilyStore.activeGroup.settings.allowRankings}
                  onChange={this.giftRankingPermissionChange}
                />
              </label>

              <label className="settings-switch-row">
                <span>Ranking Max</span>
                <input
                  className="neumorphic-input settings-small-input"
                  type="number"
                  min="1"
                  value={FamilyStore.activeGroup.settings.rankingMax}
                  onChange={(event) => this.giftRankingMaxChange(parseInt(event.target.value || '0', 10))}
                />
              </label>
            </div>

            <div className="settings-inline-module">
              <GroupSettings />
            </div>
          </div>
        ) : null}

        <div className="settings-section-card">
          <span className="settings-section-title">Child Settings</span>
          <div className="settings-section-subtitle">Control visibility of child account tools</div>
          <label className="settings-switch-row">
            <span>Show Options</span>
            <input type="checkbox" defaultChecked={this.props.UserStore.user.childOptionsVisible} onChange={this.onChildOptionsChange} />
          </label>
          {UserStore.user.childOptionsVisible ? <div className="settings-inline-module"><ChildAccounts /></div> : null}
        </div>

        <div className="settings-section-card">
          <span className="settings-section-title">Display Settings</span>
          <div className="settings-section-subtitle">Pick your visual vibe across the app</div>
          <div className="theme-studio-panel">
            <div className="theme-studio-header">
              <span className="theme-studio-title">Theme Studio</span>
              <span className="theme-studio-subtitle">Pick a palette for cards, headers, and action accents</span>
            </div>

            <div className="theme-studio-grid" role="radiogroup" aria-label="Themes">
              {themeKeys.map((themeId, i) => {
                const selected = selectedThemeIndex === i;
                return (
                  <label key={themeId} className={`theme-swatch-card ${selected ? 'is-selected' : ''}`}>
                    <input
                      type="radio"
                      name="theme"
                      value={i}
                      checked={selected}
                      onChange={this.onThemeChange}
                      className="theme-swatch-input"
                    />

                    <div className="theme-swatch-preview" aria-hidden="true">
                      <span style={{ backgroundColor: allThemes[themeId].appBackground }} />
                      <span style={{ backgroundColor: allThemes[themeId].header }} />
                      <span style={{ backgroundColor: allThemes[themeId].icons }} />
                    </div>

                    <div className="theme-swatch-meta">
                      <span className="theme-swatch-name">{allThemes[themeId].title}</span>
                      {selected ? <span className="theme-swatch-badge">Active</span> : null}
                    </div>
                  </label>
                );
              })}
            </div>
          </div>
        </div>

        <div className="settings-section-card settings-actions-card">
          <button type="button" className="neumorphic-btn settings-action-btn" onClick={() => this.setState({ modalOpen: true })}>
            Change Password
          </button>
          <button type="button" className="neumorphic-btn settings-action-btn" onClick={this.props.onLoggedOut}>
            Log Out <FaSignOutAlt />
          </button>
        </div>

        <div className="settings-section-card settings-help-card">
          <span className="settings-section-title">Need Help?</span>
          <a href="mailto:help@list.gifts" className="settings-help-link">Send us an email</a>
        </div>
      </div>
    );

    return (
      <div>
        <ModalShell className="register-modal" overlayClassName="register-modal-overlay" isOpen={this.state.modalOpen} maxWidth={640}>
          <ModalBody title="Change Password" subtitle="Update your account credentials securely">
            <div className="ui-modal-stack">
              <label className="ui-form-label AppFont">Current Password</label>
              <input className="password-spoof neumorphic-input" onChange={(event) => this.setState({ hashPass: sha512(event.target.value) })} />
              <label className="ui-form-label AppFont">New Password</label>
              <input className="password-spoof neumorphic-input" onChange={(event) => this.setState({ newHashPass: sha512(event.target.value) })} />
              <label className="ui-form-label AppFont">Confirm New Password</label>
              <input className="password-spoof neumorphic-input" onChange={(event) => this.setState({ newHashPassConfirm: sha512(event.target.value) })} />

              <div className="ui-modal-actions">
                <button className="AppFont neumorphic-btn ui-btn-success" onClick={this.onSubmitPassChangeClick} type="button">
                  <FaCheckCircle /> Submit
                </button>
                <button className="AppFont neumorphic-btn ui-btn-danger" onClick={() => this.setState({ modalOpen: false })} type="button">
                  <FaTimesCircle /> Cancel
                </button>
              </div>
            </div>
          </ModalBody>
        </ModalShell>

        <ModalShell className="register-modal" overlayClassName="register-modal-overlay" isOpen={this.state.wrongGroupModalOpen} maxWidth={700}>
          <ModalBody subtitle="Resolve active child group access" className="ui-modal-surface-wide">
            <h2 className="AppFont" style={{ color: '#222', marginTop: '10px', textAlign: 'center' }}>
              Looks like you haven't added the active child to the active group...
            </h2>
            <h1 className="AppFont" style={{ color: '#222', marginTop: '10px', textAlign: 'center' }}>
              Would you like to add {this.props.UserStore.activeChild ? this.props.UserStore.activeChild.name : 'this child'} to the group "{this.props.FamilyStore.activeGroupName}"?
            </h1>
            <div className="ui-modal-actions">
              <button type="button" className="neumorphic-btn ui-btn-success" onClick={this.addChildToGroup}>
                Yes
              </button>
              <button type="button" className="neumorphic-btn ui-btn-danger" onClick={this.dontAddChildToGroup}>
                No
              </button>
            </div>
          </ModalBody>
        </ModalShell>

        {vw < mobileWidth ? (
          <div className="header-affix">
            {UserStore.childViewActive ? (
              <div className="child-view-banner child-view-banner-mobile">
                <span style={{ color: 'white' }}>Viewing as: {UserStore.activeChild.name}</span>
              </div>
            ) : null}

            <div id="mobileMenus" style={{ zIndex: 1001, backgroundColor: UserStore.theme().header || 'white', width: '100%', height: '36px' }}>
              <MobileMenu
                disableAutoFocus
                onStateChange={this.onSettingsClicked}
                customBurgerIcon={<FaEllipsisV />}
                noTransition
                styles={
                  settingStyles({
                    bmItem: { backgroundColour: UserStore.theme().background },
                    bmBurgerBars: { backgroundColour: UserStore.theme().icons }
                  })
                }
                right
              >
                <div style={{ color: UserStore.theme().font }}>{settings}</div>
              </MobileMenu>

              <MobileMenu
                customBurgerIcon={<FaBars />}
                onClose={() => this.setState({ mobileMenuOpen: false })}
                onOpen={() => this.setState({ mobileMenuOpen: true })}
                isOpen={this.state.mobileMenuOpen}
                disableAutoFocus
                noTransition
                styles={
                  menuStyles({
                    bmItem: { backgroundColour: UserStore.theme().background },
                    bmBurgerBars: { backgroundColour: UserStore.theme().icons }
                  })
                }
                left
              >
                {navItems.map((item) => (
                  <div
                    style={mobileMenuItemStyles}
                    className="menu-item"
                    onClick={() => {
                      this.setState({ mobileMenuOpen: false, selectedKey: item.key });
                      CustomRouter.router.goTo(item.view);
                    }}
                    key={item.key}
                  >
                    {item.icon}
                    <span>{item.label}</span>
                  </div>
                ))}
              </MobileMenu>
            </div>
          </div>
        ) : (
          <header className="desktop-header" style={{ backgroundColor: UserStore.theme().header }}>
            <div className="logo" />
            {UserStore.childViewActive ? (
              <div className="child-view-banner child-view-banner-desktop">
                <span style={{ color: 'white', fontSize: '12px' }}>Viewing as: {UserStore.activeChild.name}</span>
              </div>
            ) : null}

            <div style={{ position: 'absolute', top: '1px', right: '3%' }}>
              <button type="button" className="neumorphic-btn settings-trigger-btn" onClick={this.onSettingsClicked} style={{ margin: '2px' }}>
                <FaCog />
              </button>
            </div>

            {this.state.settingsVisible ? (
              <aside className="settings-drawer-overlay" onClick={this.onClose}>
                <section className="settings-drawer" onClick={(event) => event.stopPropagation()}>
                  <button type="button" className="neumorphic-btn" style={{ alignSelf: 'flex-end' }} onClick={this.onClose}>
                    Close
                  </button>
                  <div>{settings}</div>
                </section>
              </aside>
            ) : null}

            {this.props.UserStore.role === 'guest' ? null : <nav className="topBarMenu">{navItems.map((item) => this.renderDesktopMenuItem(item))}</nav>}
          </header>
        )}
      </div>
    );
  }
}

export default MyHeader;
